import { useTranslation } from 'react-i18next';
import { BodyText } from 'vopay';
import { useAlertDialog } from 'shared';

export default function useRemoveDomainDialog() {
  const { t } = useTranslation('translations', { keyPrefix: 'Settings.EmailDomain.RemoveDialog' });
  const alertDialog = useAlertDialog();

  return async function confirmRemoveDomain(domain: string): Promise<boolean> {
    const result = await alertDialog.caution(
      t('title', { defaultValue: 'Remove {{domain}}?', domain }),
      <BodyText>
        {t('body', { defaultValue: 'Emails sent on your behalf will no longer be authenticated with this domain.' })}
      </BodyText>,
      {
        abortLabel: t('cancelButton', { defaultValue: 'Cancel' }),
        confirmLabel: t('removeButton', { defaultValue: 'Remove' }),
      },
    );

    return result === 'confirm';
  };
}
